import { fgColumnEntries } from "@redotech/redo-fulfillment-common/views/fulfillment/fg-column-catalog";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";
import { RedoTablePaddedCell } from "@redotech/redo-web/arbiter-components/tables/redo-table-cells";
import { ColumnAlignment } from "@redotech/redo-web/table";
import { Column2 } from "@redotech/redo-web/table2";
import { AddressVerificationCell } from "../cells/address-verification-cell";

const catalogEntry = fgColumnEntries["address-verification"];

export const AddressVerificationColumn: Column2<FulfillmentGroupData> = {
  alignment: ColumnAlignment.LEFT,
  key: catalogEntry.key,
  title: catalogEntry.title,
  renderNormalCell: ({ row }: { row: FulfillmentGroupData }) => (
    <RedoTablePaddedCell>
      <AddressVerificationCell row={row} />
    </RedoTablePaddedCell>
  ),
  sort: catalogEntry.sortDirection,
  width: catalogEntry.defaultWidth,
};
